import {Image} from "../../../../../core/components/image/image";
import {APP} from "../../../../../core/app/consts";
import {PartialGameViewModel} from "../../../../../domain/partial-game/models/partial-game-view-model";
import {useBetsImpression} from "../../../../../infrastructure/hooks/useBetsImpression";
import {useBookieClick} from "../../../../../infrastructure/hooks/useBookieClick";
import {Link} from "../../../../../core/components/link/link";
import {LINK_REL} from "../../../../../core/consts";

export const LiveStreamingModuleBookmaker = ({controller}) => {
  const {state} = controller;

  const betsImpressionParams = {
    bookieId: state.bookmakerId,
    bookieName: state.bookmakerName,
    sportTypeId: state.sportTypeId,
  }

  const ref = useBetsImpression(controller, betsImpressionParams);
  const {bookieHrefModel, onBookieClick} = useBookieClick(controller, {
    urlLink: state.bookmakerLink,
    currentLinkModelName: state.currentLinkModel.name,
    entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[PartialGameViewModel.name],
    entityId: state.gameId,
    status: state.statusGroup,
    bookieId: state.bookmakerId,
    buttonType: APP.ANALYTICS.BUTTON_TYPES_MAPPER.bookie,
    source: APP.ANALYTICS.SOURCES.liveStreaming
  });

  const bookmakerLogoProps = {
    className: 'live-streaming-module-bookmaker',
    src: controller.state.bookmakerLogo,
    ref
  };

  const linkProps = {
    model: bookieHrefModel,
    rel: LINK_REL.SPONSORED_NOOPENER,
    onClick: () => onBookieClick(),
  }

  return (
    <Link {...linkProps}>
      <Image {...bookmakerLogoProps}/>
    </Link>
  )
};
